module.exports = __webpack_public_path__ + "media/images/gallery/nebulae_on-5e8f07466c70fad7621ec4bbb69e8edc.gif";